<template>
  <div>
    <quill-editor
      ref="myQuillEditor"
      v-model="content"
      :options="editorOption"
      @focus="focus($event)"
      @change="onEditorChange($event)"
      @ready="onEditorReady"
      class="ql-editor"
    ></quill-editor>
    <div style="text-align: right; margin-right: 10px; margin-bottom: -5px">
      {{ TiLength }}/20000
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import {
  ImageExtend,
  QuillWatch,
} from '@/assets/script/quill-image-extend-module'
import { ImageDrop } from 'quill-image-drop-module'
import resizeImage from 'quill-image-resize-module'
import config from '@/config'
import axios from 'axios'
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', resizeImage)
export default {
  name: 'QuillEditor',
  data() {
    return {
      content: this.initContent,
      TiLength: 0,
      isDisable: true,
      editorOption: {
        placeholder: 'Please input...',
        modules: {
          toolbar: {
            container: [
              [{ size: ['small', false, 'large'] }],
              ['bold', 'italic'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link', 'image'],
              [{ align: [] }],
              [{ color: [] }, { background: [] }],
            ],
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              },
            },
          },
          clipboard: {
            matchers: [['img', this.handlePasteImg]],
          },
          imageResize: {
            //控制图片编辑的，实现功能就是这一段代码
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
          ImageExtend: {
            size: this.maxImageSize, // 单位为M, 1M = 1024KB
            sizeError: () => {
              this.$message.error(
                `Uploaded pictures cannot exceed${this.maxImageSize}M`,
              )
            },
            loading: true,
            name: 'file',
            action: `${config.baseApi}/workflow-api/credit-apply/approve/image/upload`,
            headers: xhr => {
              xhr.setRequestHeader('Authorization', this.token)
            },
            response: res => {
              const { code, message } = res
              if (code === '000000') {
                this.$message.success({
                  message: 'success',
                  description: message,
                })
              }
              return res.data
            },
          },
          imageDrop: true,
        },
      },
    }
  },
  props: {
    auditStatus: {
      type: Number,
      default: 1,
    },
    maxImageSize: {
      type: Number,
      default: 30, // 单位为M
    },
    initContent: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
  },
  watch: {
    initContent: {
      handler(remark) {
        if (remark) {
          this.content = remark
        }
      },
    },
    auditStatus: {
      handler(status) {
        if (status === 3 || status === 4) {
          this.isDisable = false
        }
      },
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
  },
  methods: {
    onEditorReady() {
      // 添加拖拽样式
      const editorElement =
        this.$refs.myQuillEditor.$el.querySelector('.ql-container')
      editorElement.style.resize = 'vertical'
      editorElement.style.overflow = 'auto'
    },
    handlePasteImg: function (node, delta) {
      let _self = this
      let base64code =
        delta &&
        delta.ops &&
        delta.ops[0] &&
        delta.ops[0]['insert'] &&
        delta.ops[0]['insert']['image']
      if (base64code && base64code.indexOf('https://') !== 0) {
        let file = _self.dataURLtoFile(base64code, 'paste.png')
        const formData = new FormData()
        formData.append('file', file)
        _self.gUpload(formData, function (res) {
          let quill = _self.$refs['myQuillEditor'].quill
          let length = quill.selection.savedRange.index
          quill.insertEmbed(length, 'image', res.data)
          quill.setSelection(length + 1)
        })
        delta.ops = []
        return delta
      } else {
        return delta
      }
    },
    // 图片的base64编码转为图片文件
    dataURLtoFile: function (dataurl, name) {
      let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], name, { type: mime })
    },
    gUpload: function (params, callBack) {
      axios({
        url: `${config.baseApi}/workflow-api/credit-apply/approve/image/upload`,
        method: 'post',
        data: params,
        headers: {
          Authorization: this.token,
        },
      }).then(res => {
        let data = res.data
        callBack(data)
      })
    },
    //获取焦点事件
    focus(event) {
      event.enable(this.isDisable) //设置富文本编辑器不可编辑
    },
    onEditorChange(event) {
      event.quill.deleteText(20000, 1)
      if (this.content === '') {
        this.TiLength = 0
      } else {
        if (this.TiLength === 19999) {
          this.$message.warning('No more than 20000 characters.')
        }
        this.TiLength = event.quill.getLength() - 1
      }
    },
    // 暴露给父组件的方法
    getContent() {
      return this.content
    },
  },
  components: {
    quillEditor,
  },
  mounted() {
    this.TiLength = this.$refs.myQuillEditor.quill.getLength() - 1
  },
}
</script>

<style lang="less">
.quill-editor {
  line-height: 1.3;
}
.quill-editor .ql-container .ql-editor {
  min-height: 20rem;
}

.ql-container {
  min-height: 400px;
}
</style>
